var scope_0 = require('/builds/bootsite/tippyjs.bootcss.com/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/builds/bootsite/tippyjs.bootcss.com/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3794cda7b82fce57efcd8d5b6ebe4edd.js').default;
var scope_2 = require('/builds/bootsite/tippyjs.bootcss.com/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/586bedef2db10baba2a0daeb2ab11d72.js').default;
var scope_3 = require('/builds/bootsite/tippyjs.bootcss.com/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c6909236d8e5a0747da483eb8c31f3fb.js').default;
var scope_4 = require('/builds/bootsite/tippyjs.bootcss.com/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d763dd53caba6f986b710739c332404c.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    